import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AttachmentDto, AttachmentHandlerOptionsDto, DownloadableDocument, FacilityPatientResultsSearchDto, FacilityPatientResultsSearchResultsDto } from 'webcommon/shared';
import { FacilityPortalHttpClientService } from '../FacilityPortalHttpClientService';

@Injectable({
  providedIn: 'root',
})
export class FacilityPatientResultsRepository {
  constructor(
    private httpClientService: FacilityPortalHttpClientService,
  ) { }

  getPatientResults(searchCriteria: FacilityPatientResultsSearchDto): Observable<FacilityPatientResultsSearchResultsDto[]> {
    const endpointUrl = `results`;
    return this.httpClientService.sendPostRequest(endpointUrl, searchCriteria);
  }

  getAttachment(AttachmentUid: string): Observable<AttachmentDto> {
    const endpointUrl = `results/attachmentdata/${AttachmentUid}`;
    return this.httpClientService.sendGetRequest(endpointUrl);
  }

  getAttachmentHandler(documentId: string): Observable<AttachmentHandlerOptionsDto> {
    const endpointUrl = `results/attachment-handler/${documentId}`;
    return this.httpClientService.sendGetRequest(endpointUrl);
  }

  getAttachmentForDownload( // may need patientId
    attachmentId: string
  ): Observable<DownloadableDocument> {
    const endpointUrl = `results/download-attachment/${attachmentId}`;
    return this.httpClientService.sendGetRequest(endpointUrl);
  }

  getObservationOrderPdf(patientId: string, resultId: string): Observable<AttachmentDto> {
    const endpointUrl = `results/observation-order-pdf/${resultId}/${patientId}`;
    return this.httpClientService.sendGetRequest(endpointUrl);
  }

  getAttachmentStaticUrl(attachmentId: string): Observable<string> {
    const endpointUrl = `results/attachments-url/${attachmentId}`;
    return this.httpClientService.sendGetRequest(endpointUrl);
  }
}
